// extracted by mini-css-extract-plugin
export default {"footerSection":"FooterSection_footerSection__-AhcH","footerContent":"FooterSection_footerContent__Cxavn","apkWindowFooter":"FooterSection_apkWindowFooter__Vey5n"};